import type { EraManifest } from '../science/types';

export const ERA_MANIFESTS: EraManifest[] = [
  {
    id: 'modern',
    label: 'Modern / 2020s',
    subtitle: 'Correlated Quantum Vacuum',
    accent: '#3ca7ff',
    accentSoft: '#8d56ff',
    panel: '#071b31',
    panelRaised: '#0b2745',
    screen: '#06182b',
    metal: '#2f526f',
    defaultPreset: '2019 Electro-Optic Vacuum Correlations',
    description: 'Two-probe electromagnetic vacuum correlations with field, spectrum, quadrature, and detector views.',
    apparatusLabel: 'Electro-Optic Correlation Laboratory',
    availableBoundaries: ['none', 'plates', 'sphere', 'cavity', 'waveguide', 'custom']
  },
  {
    id: '2010s',
    label: '2010s',
    subtitle: 'Vacuum Becomes Light',
    accent: '#3f9fff',
    accentSoft: '#d14cff',
    panel: '#07192d',
    panelRaised: '#182238',
    screen: '#071a2f',
    metal: '#6a4a2c',
    defaultPreset: '2011 Dynamical Casimir Circuit',
    description: 'Boundary modulation, microwave photon production, and two-mode squeezing in superconducting circuits.',
    apparatusLabel: 'Superconducting Circuit',
    availableBoundaries: ['cavity', 'waveguide', 'custom']
  },
  {
    id: '1990s-2000s',
    label: '1990s–2000s',
    subtitle: 'Quantum Optics Laboratory',
    accent: '#8bcf36',
    accentSoft: '#7c5cff',
    panel: '#07192a',
    panelRaised: '#11251e',
    screen: '#061812',
    metal: '#3b443d',
    defaultPreset: 'Squeezed Vacuum Homodyne Laboratory',
    description: 'Optical cavities, squeezed quadratures, balanced homodyne detection, and phase-space views.',
    apparatusLabel: 'Quantum Optics Bench',
    availableBoundaries: ['none', 'cavity', 'plates', 'custom']
  },
  {
    id: '1970s-1980s',
    label: '1970s–1980s',
    subtitle: 'Dynamic Boundaries',
    accent: '#e99a25',
    accentSoft: '#abcf43',
    panel: '#111a21',
    panelRaised: '#35281c',
    screen: '#08130c',
    metal: '#6a4b2b',
    defaultPreset: 'Moving-Mirror Parametric Model',
    description: 'Variable-length cavities, moving boundaries, mode amplification, and theoretical dynamical Casimir precursors.',
    apparatusLabel: 'Variable-Length Cavity',
    availableBoundaries: ['plates', 'cavity', 'waveguide', 'custom']
  },
  {
    id: '1950s-1960s',
    label: '1950s–1960s',
    subtitle: 'Atomic Age Vacuum',
    accent: '#e2ae35',
    accentSoft: '#4b7cff',
    panel: '#091a2e',
    panelRaised: '#302b23',
    screen: '#08172d',
    metal: '#b9a577',
    defaultPreset: 'Casimir Parallel Plates',
    description: 'Static boundaries, mode-density differences, cavity geometries, and atom-surface interactions.',
    apparatusLabel: 'Casimir Boundary Chamber',
    availableBoundaries: ['plates', 'sphere', 'cavity', 'waveguide', 'custom']
  },
  {
    id: '1940s',
    label: '1940s Foundations',
    subtitle: 'Atomic Spectra to Vacuum',
    accent: '#d4a23d',
    accentSoft: '#dad0ad',
    panel: '#111c27',
    panelRaised: '#4b4131',
    screen: '#161711',
    metal: '#c1ad7c',
    defaultPreset: 'Lamb–Retherford Spectroscopy',
    description: 'Atomic energy shifts, spectroscopy, early quantum electrodynamics, and the conceptual foundations of vacuum effects.',
    apparatusLabel: 'Microwave Spectrometer',
    availableBoundaries: ['none', 'custom']
  }
];

export const getEra = (id: EraManifest['id']): EraManifest => {
  const era = ERA_MANIFESTS.find((item) => item.id === id);
  if (!era) throw new Error(`Unknown era: ${id}`);
  return era;
};
